<script>
import { resolveColorToken, tintRgba } from '@modules/global/utils/Color'

export default {
  name: 'IconWithBackground',
  inheritAttrs: false,
  props: {
    containerSize: { type: Number, default: 20 },
    icon: { type: String, default: 'check-circle' },
    iconSize: { type: Number, default: 16 },
    color: { type: String, default: 'primary' },
    opacity: { type: Number, default: 0.15 },
    rounded: { type: Boolean, default: false },
    // sem fundo: so o icone na cor (ex.: timeline de tarefas, cor primary)
    transparent: { type: Boolean, default: false },
    // Cor do ÍCONE, separada da cor do FUNDO (`color`). Opcional e
    // retrocompatível: sem ela, o ícone continua na MESMA cor resolvida que
    // o fundo usa (comportamento idêntico ao anterior a esta prop). Usado
    // pelo card do painel de artefato (estado ativo: fundo sólido `primary`
    // + ícone branco).
    iconColor: { type: String, default: null },
  },
  computed: {
    colorResolved() {
      return this.resolveColor(this.color)
    },
    // A cor do fundo — nunca muda de significado com `iconColor` presente.
    backgroundColorToken() {
      return this.colorResolved
    },
    // A cor do ÍCONE: `iconColor` quando fornecida, senão a MESMA de sempre.
    iconColorResolved() {
      if (!this.iconColor) return this.colorResolved
      return this.resolveColor(this.iconColor)
    },
    backgroundColor() {
      if (this.transparent) return 'transparent'
      return this.hexToRgbaString(this.backgroundColorToken, this.opacity)
    },
    containerStyle() {
      return {
        width: this.containerSize + 'px',
        height: this.containerSize + 'px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: this.rounded ? '50%' : '4px',
        backgroundColor: this.backgroundColor,
      }
    },
  },
  methods: {
    resolveColor(color) {
      return resolveColorToken(color)
    },
    hexToRgbaString(hex, opacity) {
      return tintRgba(hex, opacity)
    },
  },
}
</script>

<template>
  <div :style="containerStyle" v-bind="$attrs" v-on="$listeners">
    <icon-svg :name="icon" :color="iconColorResolved" :size="iconSize" />
  </div>
</template>
